import ReadyToDepositModal from './ready-to-deposit-modal';

export default ReadyToDepositModal;
